import {Bars} from 'react-loader-spinner'
import axios from "axios";
import moment from "moment";
import React, {useContext, useEffect, useState} from "react";
import Chart from "../../Chart/Chart";
import {authContext} from "../../Context/Authentication/authContext";
import "./Price.scss";
import {baseURL} from "../../config";
import {generateChartData, getAdjustedPredictionData, getAdjustedSentimentData} from '../../Helpers/helpers'
import WChart from '../../WhatIfAnalysis/Chart/Chart';

const Price = () => {
  const {state}: any = useContext(authContext);
  const [chartData, setChartData]: any = useState(null);
  const [isSort, setSort]: any = useState(true)
  const [percentageTooltip, setPercentageTooltip]: any = useState(false);
  const [isAdjustedPrediction, setIsAdjustedPrediction]: any = useState(false);
  useEffect(() => {
    setChartData(null);
    if (state.filters.predictionsArray.length != 0) {
      setIsAdjustedPrediction(true);
      getAllPredictionData()
      // state.filters.predictionsArray.map((t: any) => {
      //   console.log(t);

      //   if (t == "Mortgage Rates") {
      //     if (
      //       state.filters.refreshAdjustedPredictionSubmit &&
      //       state.filters.zipcode?.length === 0
      //     ) {
      //       setIsAdjustedPrediction(true);
      //       getAdjustedPrediction();
      //     }
      //   } else if (t == "Consumer Sentiments(HPSI)") {
      //     if (
      //       state.filters.refreshAdjustedSentimentSubmitByConsumer &&
      //       state.filters.zipcode?.length === 0
      //     ) {
      //       setIsAdjustedPrediction(true);
      //       getAdjustedSentiment("consumer");
      //     }
      //   } else if (t == "Builder Sentiments(NAHB)") {
      //     if (
      //       state.filters.refreshAdjustedSentimentSubmitByBuilder &&
      //       state.filters.zipcode?.length === 0
      //     ) {
      //       setIsAdjustedPrediction(true);
      //       getAdjustedSentiment("builder");
      //     }
      //   }
      // });
    }
    
    else {
      setIsAdjustedPrediction(false)
      if (state.filters.value.toLowerCase() === 'percentage') {
        if (state.filters.zipcode?.length) {
          setPercentageTooltip(true)
          setSort(true)
          getPPSFZipcodePercentageChange()
        } else {
          setPercentageTooltip(true)
          setSort(true)
          getPPSFPercentageChange()
        }
      } else {
        if (state.filters.showInterval && state.filters.zipcode?.length === 0) {
          setPercentageTooltip(false)
          setSort(false)
          getPPSFByInterval();
        } else if (state.filters.zipcode?.length && state.filters.showInterval) {
          setPercentageTooltip(false)
          setSort(false)
          getPPSFZipcodeByInterval();
        } else if (state.filters.zipcode?.length && !state.filters.showInterval) {
          setPercentageTooltip(false)
          setSort(true)
          getPPSFByZip();
        } else {
          setPercentageTooltip(false)
          setSort(true)
          getPPSF();
        }
      }
    }
  }, [
    state.filters.years,
    state.filters.city,
    state.filters.zipcode,
    state.filters.value,
    state.filters.showInterval,
    state?.filters?.selectedType,
    state?.filters?.regionType,
    state?.filters?.neighborhood,
    state.filters.refreshAdjustedPredictionSubmit,
    state.filters.refreshAdjustedSentimentSubmitByConsumer,
    state.filters.refreshAdjustedSentimentSubmitByBuilder
  ]);

  const getAllPredictionData=()=>{
    if (state.filters.predictionsArray.length != 0) {
      let mainarr: any = [];
      let res1: any = [];
      let res2: any = [];
      let res3: any = [];
    
      // Create an array of promises for each async call
      const promises = state.filters.predictionsArray.map(async (t: any) => {
        if (t == "Mortgage Rates") {
          const query = `${state.filters.state}/${state.filters.city[0]}/city`;
          let data = state.filters.adjustedPredictionValues;
          delete data.status;
          res1 = await getAdjustedPredictionData(query, data, "ppsf");
          console.log(res1, 'resp1');
        } else if (t == "Consumer Sentiments(HPSI)") {
          let type = 'consumer';
          const query = `${state.filters.state}/${state.filters.city[0]}/city`;
          let data =
            type === "consumer"
              ? state.filters.adjustedSentimentValuesByConsumer
              : state.filters.adjustedSentimentValuesByBuilder;
          delete data.status;
          res2 = await getAdjustedSentimentData(query, data, `ppsf/${type}`);
          console.log(res2, 'resp2');
        } else if (t == "Builder Sentiments(NAHB)") {
          let type = 'builder';
          const query = `${state.filters.state}/${state.filters.city[0]}/city`;
          let data =
            type === "consumer"
              ? state.filters.adjustedSentimentValuesByConsumer
              : state.filters.adjustedSentimentValuesByBuilder;
          delete data.status;
          res3 = await getAdjustedSentimentData(query, data, `ppsf/${type}`);
          console.log(res3, 'resp3');
        }
      });
    
      // Wait for all promises to resolve
      Promise.all(promises)
      .then(() => {
        if(res1.length>0){
          res1.forEach((item: any, index: any) => {
            mainarr.push({
              date: item.date,
              actual_predictions: item.actual_predictions,
              adjusted_prediction: res1[index]?.adjusted_prediction || "",
              consumer_adjusted_prediction: res2[index]?.adjusted_prediction || "",
              builder_adjusted_prediction: res3[index]?.adjusted_prediction || "",
            });
          });

        }
        else if(res2.length>0){
          res2.forEach((item: any, index: any) => {
            mainarr.push({
              date: item.date,
              actual_predictions: item.actual_predictions,
              adjusted_prediction: res1[index]?.adjusted_prediction || "",
              consumer_adjusted_prediction: res2[index]?.adjusted_prediction || "",
              builder_adjusted_prediction: res3[index]?.adjusted_prediction || "",
            });
          });

        }
        else if(res3.length>0){
          res3.forEach((item: any, index: any) => {
            mainarr.push({
              date: item.date,
              actual_predictions: item.actual_predictions,
              adjusted_prediction: res1[index]?.adjusted_prediction || "",
              consumer_adjusted_prediction: res2[index]?.adjusted_prediction || "",
              builder_adjusted_prediction: res3[index]?.adjusted_prediction || "",
            });
          });

        }

        console.log(mainarr);
        setChartData(mainarr)
      })
      .catch((error) => {
        console.error('Error occurred:', error);
      });
    }
    

  }


  // useEffect(() => {
  //   setChartData(null);
  //   if (state.filters.refreshAdjustedPredictionSubmit  && state.filters.zipcode?.length === 0) {
  //     setIsAdjustedPrediction(true)
  //     getAdjustedPrediction()
  //   } 
  //   else if (state.filters.refreshAdjustedSentimentSubmitByConsumer  && state.filters.zipcode?.length === 0) {
  //     console.log('jkplll')
  //     setIsAdjustedPrediction(true)
  //     getAdjustedSentiment('consumer')
  //   } 
  //   else if (state.filters.refreshAdjustedSentimentSubmitByBuilder  && state.filters.zipcode?.length === 0) {
  //     console.log('jkp')
  //     setIsAdjustedPrediction(true)
  //     getAdjustedSentiment('builder')
  //   } 
    
  //   else {
  //     setIsAdjustedPrediction(false)
  //     if (state.filters.value.toLowerCase() === 'per') {
  //       if (state.filters.zipcode?.length) {
  //         setPercentageTooltip(true)
  //         setSort(true)
  //         getPPSFZipcodePercentageChange()
  //       } else {
  //         setPercentageTooltip(true)
  //         setSort(true)
  //         getPPSFPercentageChange()
  //       }
  //     } else {
  //       if (state.filters.showInterval && state.filters.zipcode?.length === 0) {
  //         setPercentageTooltip(false)
  //         setSort(false)
  //         getPPSFByInterval();
  //       } else if (state.filters.zipcode?.length && state.filters.showInterval) {
  //         setPercentageTooltip(false)
  //         setSort(false)
  //         getPPSFZipcodeByInterval();
  //       } else if (state.filters.zipcode?.length && !state.filters.showInterval) {
  //         setPercentageTooltip(false)
  //         setSort(true)
  //         getPPSFByZip();
  //       } else {
  //         setPercentageTooltip(false)
  //         setSort(true)
  //         getPPSF();
  //       }
  //     }
  //   }
  // }, [
  //   state.filters.years,
  //   state.filters.city,
  //   state.filters.zipcode,
  //   state.filters.value,
  //   state.filters.showInterval,
  //   state?.filters?.selectedType,
  //   state?.filters?.regionType,
  //   state?.filters?.neighborhood,
  //   state.filters.refreshAdjustedPredictionSubmit,
  //   state.filters.refreshAdjustedSentimentSubmitByConsumer,
  //   state.filters.refreshAdjustedSentimentSubmitByBuilder
  // ]);

  const getAdjustedSentiment = async (type:string) => {
    const query = `${state.filters.state}/${state.filters.city[0]}/city`
    let data = type ==='consumer'?state.filters.adjustedSentimentValuesByConsumer:state.filters.adjustedSentimentValuesByBuilder
    delete data.status
    const resp = await getAdjustedSentimentData(query, data, `ppsf/${type}`)
    console.log(resp)
    setChartData(resp)
  }


  const getAdjustedPrediction = async () => {
    const query = `${state.filters.state}/${state.filters.city[0]}/city`
    let data = state.filters.adjustedPredictionValues
    delete data.status
    const resp = await getAdjustedPredictionData(query, data, 'ppsf')
    setChartData(resp)
  }

  const getPPSFPercentageChange = async () => {
    try {
      const city = JSON.stringify(state.filters.city)
      .replace(/^\[|\]$/g, "") // Only removes the starting and ending square brackets
      .replaceAll('"', "'");
      const response = await axios.get(`${baseURL}getPPSFPctChange?state=${state.filters.state}&city=${city}`);
      const data = generateChartData(response?.data?.cube, 'ppsf', true);
      setChartData(data);
    } catch (e) {
      console.log("error", e);
    }

  }

  const getPPSFZipcodePercentageChange = async () => {
    try {
      const zipcodes = JSON.stringify(
        state.filters.zipcode.map((item: string) => item.split("_")[0])
      )
        .replace(/[\[\]']+/g, "")
        .replaceAll('"', "'");
      const response = await axios.get(
        `${baseURL}getPPSFZipcodePctChange?state=${state.filters.state}&zipcode=${zipcodes}`
      );
      const data = generateChartData(response.data?.cube, 'ppsf', true);
      setChartData(data);
    } catch (error) {
      console.log("error", error);
    }
  }

  const getPPSF = async () => {
    const start = state.filters.years[0];
    const end = state.filters.years[1];
    try {
      const city = JSON.stringify(state.filters.city)
      .replace(/^\[|\]$/g, "") // Only removes the starting and ending square brackets
      .replaceAll('"', "'");
      const response = await axios.get(
        `${baseURL}getPPSF?state=${state.filters.state}&city=${city}&startYear=${start}&endYear=${end}&flag=${state.filters.value.toLowerCase()}`
      );
      const data = generateChartData(response.data?.cube, 'ppsf');
      setChartData(data);
    } catch (error) {
      console.log("error", error);
    }
  };

  const getPPSFByZip = async () => {
    const start = state.filters.years[0];
    const end = state.filters.years[1];
    try {
      const zipcode = JSON.stringify(
        state.filters.zipcode.map((item: string) => item.split("_")[0])
      )
        .replace(/[\[\]']+/g, "")
        .replaceAll('"', "'");
      const response = await axios.get(
        `${baseURL}getPPSFZipcode?state=${state.filters.state}&zipcode=${zipcode}&startYear=${start}&endYear=${end}&flag=${state.filters.value.toLowerCase()}`
      );
      const data = generateChartData(response.data?.cube, 'ppsf');
      setChartData(data);
    } catch (error) {
      console.log("error", error);
    }
  };

  const getPPSFZipcodeByInterval = async () => {
    const start = state.filters.years[0];
    const end = state.filters.years[1];
    try {
      const zipcode = JSON.stringify(
        state.filters.zipcode.map((item: string) => item.split("_")[0])
      )
        .replace(/[\[\]']+/g, "")
        .replaceAll('"', "'");
      const response = await axios.get(
        `${baseURL}getPPSFZipcodeInterval?state=${state.filters.state}&zipcode=${zipcode}&startYear=${start}&endYear=${end}&flag=${state.filters.value.toLowerCase()}`
      );
      const data = generateIntervalChartData(response.data?.cube);
      setChartData(data);
    } catch (error) {
      console.log("error", error);
    }
  };

  const getPPSFByInterval = async () => {
    const city = JSON.stringify(state.filters.city)
    .replace(/^\[|\]$/g, "") // Only removes the starting and ending square brackets
    .replaceAll('"', "'");
    const start = state.filters.years[0];
    const end = state.filters.years[1];
    try {
      const response = await axios.get(
        `${baseURL}getPPSFByInterval?state=${state.filters.state}&city=${city}&startYear=${start}&endYear=${end}&flag=${state.filters.value.toLowerCase()}`
      );
      const data = generateIntervalChartData(response.data?.cube);
      setChartData(data);
    } catch (error) {
      console.log("error", error);
    }
  };

  const generateIntervalChartData = (apiData: any) => {
    try {
      const data: any = apiData.map((item: any) => {
        return {
          date: moment(item?.date).format("YYYY-MM-DD"),
          value1: item?.ppsfHigh,
          value2: item?.ppsfLow,
          value3: item?.ppsf,
        };
      });
      return data;
    } catch (error) {
      console.log(error);
    }
  };

  const getSelectValue=()=>{
    switch(state.filters.value){
      case 'Absolute':
        return 'Absolute'
      case 'growth':
          return ' Growth (Month on Month)'
      case 'trend':
            return 'Long Term Trend'
     case 'percentage':
              return 'Percentage'
      
    }
  }

  return (
    <div className="price-main prediction-chart">
       {chartData?.length && !isAdjustedPrediction ? (
        <div className="price-main__text">
          Median Price Per Square Feet in {state.filters.value === 'percentage' ? 'Growth' : '$,'} {getSelectValue()}
        </div>
      ) : null}
      <div className="price-main__chartContainer">
        {chartData === null ? (
          <div className="price-main__chartContainer__isLoading">
            <Bars height='400' ariaLabel='bars-loading' wrapperClass='tab-spinner-progress-bar' visible={true}/>
          </div>
        ) : chartData?.length ? (
          <>
            {isAdjustedPrediction ? (
              <WChart
                chartData={chartData}
                chartId={'ppsf-chart'}
                title='Adjusted PPSF Projection  '
                isMulti
                isPredition
                isSetToZoom
              />
            ) : (
              <Chart
                chartData={chartData}
                title={`PPSF ${['growth', 'per'].includes(state.filters.value.toLowerCase()) ? '(%)' : '($)'}`}
                city={isSort ? state.filters.city.sort() : state.filters.city}
                zipcode={isSort ? state.filters.zipcode.sort() : state.filters.zipcode}
                showInterval={state.filters.showInterval}
                percentageTooltip={percentageTooltip}
                percentageType={percentageTooltip ? 'PPSF' : ''}
              />
            )}

          </>
        ) : (
          <div className="price-main__chartContainer__noData">
            No Data Available
          </div>
        )}
      </div>
    </div>
  );
};

export default React.memo(Price);
